import ArticleLayout from "@/components/feature/ArticleLayout";
import { articleDataList } from "@/mocks/articles";

export default function CategoryGuidePage() {
  const article = articleDataList.find((a) => a.slug === "mulebuy-spreadsheet-category-guide")!;
  return <ArticleLayout article={article} />;
}